var tracking_aid;
var tracking_oid;
var tracking_tid;
var tracking_sub1;
var tracking_sub2;
var tracking_sub3;

$(function()
{
	tracking_aid = tracking_get_url_param(window.location.href, 'aid');
	if (!tracking_aid)
	{
		tracking_aid = Cookies.get('tracking_aid');
	}
	if (tracking_aid)
	{
		Cookies.set('tracking_aid', tracking_aid);
	}
	
	tracking_oid = tracking_get_url_param(window.location.href, 'oid');
	if (!tracking_oid)
	{
		tracking_oid = Cookies.get('tracking_oid');
	}
	if (tracking_oid)
	{
		Cookies.set('tracking_oid', tracking_oid);
	}
	
	tracking_tid = tracking_get_url_param(window.location.href, 'tid');
	if (!tracking_tid)
	{
		tracking_tid = Cookies.get('tracking_tid');
	}
	if (tracking_tid)
	{
		Cookies.set('tracking_tid', tracking_tid);
	}
	
	tracking_sub1 = tracking_get_url_param(window.location.href, 'sub1');
	if (!tracking_sub1)
	{
		tracking_sub1 = Cookies.get('tracking_sub1');
	}
	if (tracking_sub1)
	{
		Cookies.set('tracking_sub1', tracking_sub1);
	}
	
	tracking_sub2 = tracking_get_url_param(window.location.href, 'sub2');
	if (!tracking_sub2)
	{
		tracking_sub2 = Cookies.get('tracking_sub2');
	}
	if (tracking_sub2)
	{
		Cookies.set('tracking_sub2', tracking_sub2);
	}
	
	tracking_sub3 = tracking_get_url_param(window.location.href, 'sub3');
	if (!tracking_sub3)
	{
		tracking_sub3 = Cookies.get('tracking_sub3');
	}
	if (tracking_sub3)
	{
		Cookies.set('tracking_sub3', tracking_sub3);
	}
	
	console.log('tracking_aid = ' + tracking_aid);
	console.log('tracking_oid = ' + tracking_oid);
	console.log('tracking_tid = ' + tracking_tid);
	console.log('tracking_sub1 = ' + tracking_sub1);
	console.log('tracking_sub2 = ' + tracking_sub2);
	console.log('tracking_sub3 = ' + tracking_sub3);
	
	var tracking_aid_el = $('input[name="attributes[aid]"]');
	if (tracking_aid_el.length > 0 && tracking_aid)
	{
		tracking_aid_el.val(tracking_aid);
	}
	
	var tracking_oid_el = $('input[name="attributes[oid]"]');
	if (tracking_oid_el.length > 0 && tracking_oid)
	{
		tracking_oid_el.val(tracking_oid);
	}
	
	var tracking_tid_el = $('input[name="attributes[tid]"]');
	if (tracking_tid_el.length > 0 && tracking_tid)
	{
		tracking_tid_el.val(tracking_tid);
	}
	
	var tracking_sub1_el = $('input[name="attributes[sub1]"]');
	if (tracking_sub1_el.length > 0 && tracking_sub1)
	{
		tracking_sub1_el.val(tracking_sub1);
	}
	
	var tracking_sub2_el = $('input[name="attributes[sub2]"]');
	if (tracking_sub2_el.length > 0 && tracking_sub2)
	{
		tracking_sub2_el.val(tracking_sub2);
	}
	
	var tracking_sub3_el = $('input[name="attributes[sub3]"]');
	if (tracking_sub3_el.length > 0 && tracking_sub3)
	{
		tracking_sub3_el.val(tracking_sub3);
	}
});

function tracking_get_url_param(url, key)
{
	var url_parts = url.split('?');
	var search = url_parts.length >= 2 ? url_parts[1] : '';
	let search_params = new URLSearchParams(url_parts[1]);
	var values = search_params.get(key);
	return values;
}
